import { Common } from '@stockbit/ui';
import HtmlParser from 'html-react-parser';

import Image from 'global/Image';
import { TabWrapper, TabPane, Tabs } from '../styled';

const { Flex, Modal, Text } = Common;

const limitOrderDesc =
  'adalah perintah untuk membeli saham pada harga tertentu sesuai harga yang telah kamu tentukan.';
const autoBuyDesc =
  'adalah perintah untuk membeli saham dengan kondisi <i>(Trigger Price)</i> yang sudah kamu tentukan. Jika kondisi harga saham terpenuhi, maka order beli akan dikirim secara otomatis';

function OrderTypeModal({ visible, closeModal }) {
  return (
    <Modal visible={visible} centered onCancel={closeModal}>
      <Text size="20px" align="center" family="bold" padding="15px">
        Order Type
      </Text>
      <TabWrapper>
        <Tabs defaultActiveKey="1" centered>
          <TabPane tab="Limit Order" key="1">
            <Flex
              direction="column"
              padding="15px"
              align="center"
              justify="center"
            >
              <Image src="/img/limit-order.svg" alt="limit-order" />
              <Text family="bold" my="15px">
                Limit Order{' '}
                <Text style={{ display: 'inline' }}>{limitOrderDesc}</Text>
              </Text>
            </Flex>
          </TabPane>
          <TabPane tab="Auto Buy" key="2">
            <Flex
              direction="column"
              padding="20px"
              align="center"
              justify="center"
            >
              <Image src="/img/auto-buy.svg" alt="limit-order" />
              <Text family="bold" my="15px">
                Auto Buy{' '}
                <Text style={{ display: 'inline' }}>
                  {HtmlParser(autoBuyDesc)}
                </Text>
              </Text>
            </Flex>
          </TabPane>
        </Tabs>
      </TabWrapper>
    </Modal>
  );
}

export default OrderTypeModal;
